import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

// Lucide React (atual)
import { Home, Settings, Plus, Trash2, Edit, Save, X, LogOut, Sun, Paintbrush } from 'lucide-react';

// Phosphor Icons
import { 
  House, Gear, PlusCircle, TrashSimple, PencilSimple, FloppyDisk, XCircle, 
  SignOut, Sun as PhosphorSun, Palette 
} from 'phosphor-react';

// Heroicons
import { 
  HomeIcon, Cog6ToothIcon, PlusCircleIcon, TrashIcon, PencilIcon, 
  ArrowDownTrayIcon, XCircleIcon, ArrowRightOnRectangleIcon,
  SunIcon, PaintBrushIcon
} from '@heroicons/react/24/outline';

import { 
  HomeIcon as HomeIconSolid, Cog6ToothIcon as CogSolid, PlusCircleIcon as PlusSolid,
  TrashIcon as TrashSolid, PencilIcon as PencilSolid
} from '@heroicons/react/24/solid';

export default function IconsDemo() {
  const iconSize = 24;
  
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-7xl mx-auto space-y-8">
        <div>
          <h1 className="text-4xl font-bold mb-2">Comparação de Ícones</h1>
          <p className="text-muted-foreground">
            Escolha o estilo que combina melhor com o sistema
          </p>
        </div>

        {/* Lucide React - Atual */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <span>1. Lucide React (Atual)</span>
              <span className="text-sm font-normal text-muted-foreground">Stroke-width: 2 (padrão)</span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-5 md:grid-cols-10 gap-6">
              <div className="flex flex-col items-center gap-2">
                <Home size={iconSize} />
                <span className="text-xs text-muted-foreground">Home</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Settings size={iconSize} />
                <span className="text-xs text-muted-foreground">Settings</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Plus size={iconSize} />
                <span className="text-xs text-muted-foreground">Plus</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Trash2 size={iconSize} />
                <span className="text-xs text-muted-foreground">Trash</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Edit size={iconSize} />
                <span className="text-xs text-muted-foreground">Edit</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Save size={iconSize} />
                <span className="text-xs text-muted-foreground">Save</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <X size={iconSize} />
                <span className="text-xs text-muted-foreground">Close</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <LogOut size={iconSize} />
                <span className="text-xs text-muted-foreground">Logout</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Sun size={iconSize} />
                <span className="text-xs text-muted-foreground">Sun</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Paintbrush size={iconSize} />
                <span className="text-xs text-muted-foreground">Paint</span>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Lucide React - Mais Fino */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <span>2. Lucide React - Thin</span>
              <span className="text-sm font-normal text-muted-foreground">Stroke-width: 1.5 (mais fino)</span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-5 md:grid-cols-10 gap-6">
              <div className="flex flex-col items-center gap-2">
                <Home size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Home</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Settings size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Settings</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Plus size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Plus</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Trash2 size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Trash</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Edit size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Edit</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Save size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Save</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <X size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Close</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <LogOut size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Logout</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Sun size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Sun</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Paintbrush size={iconSize} strokeWidth={1.5} />
                <span className="text-xs text-muted-foreground">Paint</span>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Phosphor Icons - Light */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <span>3. Phosphor Icons - Light</span>
              <span className="text-sm font-normal text-muted-foreground">Estilo minimalista e elegante</span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-5 md:grid-cols-10 gap-6">
              <div className="flex flex-col items-center gap-2">
                <House size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Home</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Gear size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Settings</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PlusCircle size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Plus</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <TrashSimple size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Trash</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PencilSimple size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Edit</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <FloppyDisk size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Save</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <XCircle size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Close</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <SignOut size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Logout</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PhosphorSun size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Sun</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Palette size={iconSize} weight="light" />
                <span className="text-xs text-muted-foreground">Paint</span>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Phosphor Icons - Duotone */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <span>4. Phosphor Icons - Duotone</span>
              <span className="text-sm font-normal text-muted-foreground">Dois tons, mais sofisticado</span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-5 md:grid-cols-10 gap-6">
              <div className="flex flex-col items-center gap-2">
                <House size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Home</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Gear size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Settings</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PlusCircle size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Plus</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <TrashSimple size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Trash</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PencilSimple size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Edit</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <FloppyDisk size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Save</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <XCircle size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Close</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <SignOut size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Logout</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PhosphorSun size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Sun</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Palette size={iconSize} weight="duotone" />
                <span className="text-xs text-muted-foreground">Paint</span>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Heroicons - Outline */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <span>5. Heroicons - Outline</span>
              <span className="text-sm font-normal text-muted-foreground">Do Tailwind CSS, clean</span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-5 md:grid-cols-10 gap-6">
              <div className="flex flex-col items-center gap-2">
                <HomeIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Home</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <Cog6ToothIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Settings</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PlusCircleIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Plus</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <TrashIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Trash</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PencilIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Edit</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <ArrowDownTrayIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Save</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <XCircleIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Close</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <ArrowRightOnRectangleIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Logout</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <SunIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Sun</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PaintBrushIcon className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Paint</span>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Heroicons - Solid */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <span>6. Heroicons - Solid</span>
              <span className="text-sm font-normal text-muted-foreground">Preenchido, mais impactante</span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-5 md:grid-cols-10 gap-6">
              <div className="flex flex-col items-center gap-2">
                <HomeIconSolid className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Home</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <CogSolid className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Settings</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PlusSolid className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Plus</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <TrashSolid className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Trash</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <PencilSolid className="w-6 h-6" />
                <span className="text-xs text-muted-foreground">Edit</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
